import React from "react";
import Label from "./Label";

const CoursePlc = (props) => {
  const key = "plc-key";
  const display = (
    <div
      className="col-9 justify-content-left md-font card inner-buffer"
      onClick={(e) => props.focus(key, e)}
    >
      {props.plcLink}
    </div>
  );

  const input = (
    <textarea
      id={key + "input"}
      className="col-9"
      maxLength={255}
      style={{ fontSize: "2rem" }}
      value={props.plcLink}
      onChange={(e) => props.handleChange({ type: "plc_link" }, e)}
      onClick={(e) => props.focus(key, e)}
    />
  );

  if (props.editMode == true) {
    return (
      <div id={key} className="d-flex flex-row justify-content-left top-buffer">
        <Label boxed={true} text="Course PLC:" />
        {props.focusKey == key ? input : display}
      </div>
    );
  } else {
    const url = props.plcLink;
    const valid = /^(ftp|http|https):\/\/[^ "]+$/.test(url);
    return (
      <div
        id={key}
        className="d-flex flex-row justify-content-left top-buffer"
        style={{ marginTop: 10, height: 44 }}
      >
        <Label boxed={true} text="Course PLC:" />
        <a
          href={valid ? props.plcLink : ""}
          target="_blank"
          type="button"
          className={
            !valid
              ? "btn btn-primary ml-3 mt-1 disabled"
              : "btn btn-primary ml-3 mt-1"
          }
          aria-disabled="true"
          tabIndex="-1"
        >
          Visit PLC
        </a>
      </div>
    );
  }
};

export default CoursePlc;
